import { SDKbaseURI, SDKbaseURIkey, webBaseURI, cartURI, inventoryURI, searchAPI, searchAPIPageSize, configsAPI, useCache, reStyleURI, reStyleReferencesAPI, reStyleCategories, reStyleUploadSelfie, reStyleSetHairstyles, reStyleGetSelfies, reStyleURIkey, reStyleGetConfigs, reStyleGetTransfers, nftActivityURI, nftActivityAPIKey } from '../config.js'

const APIhelper = {
    fetchRetry: function (url, options, tries = 3) {
        const that = this;
        return fetch(url, options)
            // return fetch(tries > 2 ? url.replace('.com', '.com4') : url, options)
            .then((resp) => {
                console.log('# fetchRetry ok ', resp)
                return resp;
            }, (err) => {
                if (tries < 1) {
                    console.log('# fetchRetry throw ', err);
                    throw err;
                } else {
                    console.log('# fetchRetry retry ', err);
                    return that.fetchRetry(url, options, tries - 1);
                }
            });
    },
    cache: function (key, fn, stringify) {
        key = `${key}-${new Date().toISOString().split('T')[0]}`;
        const response = window.sessionStorage.getItem(key);
        if (response) {
            return new Promise((resolve, reject) => resolve(stringify ? JSON.parse(response) : response));
        }

        return fn()
            .then(r => {
                try {
                    window.sessionStorage.setItem(key, stringify ? JSON.stringify(r) : r);
                } catch (error) {
                    gtag('event', 'exception', {
                        'description': 'failed to save into sessionStorage',
                        'fatal': false
                    });
                }
                return r;
            });
    },
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'x-api-key': SDKbaseURIkey,
    },
    dummyProduct: function () {
        return {
            productId: Math.random(),
            productImage: '',
            productBrand: '',
            productName: '',
            palettes: []
        }
    },
    fetchConfigs: function () {
        const fn = (() => {
            return fetch(SDKbaseURI + configsAPI, {
                headers: this.headers
            })
                .then(response => response.json())
                .then((response) => {
                    // response.data.Effects = ['./public/2021-11-30-12-33-15-492_all_web_effects.json'];
                    return response.data;
                });
        }).bind(this);
        if (useCache) {
            // return this.retry(this.cache.bind(this, 'configs', fn, true), 3);
            return this.cache('configs', fn, true);
        } else {
            // return this.retry(fn);
            return fn();
        }

    },
    fetchByProdSku: function (productUltaId, sku) {
        const fn = (() => {

            const filter = {};
            productUltaId && (filter.ProductUltaIds = [productUltaId]);
            sku && (filter.SKUs = [sku]);
            const body = {
                page: 1,
                pageSize: 1,
                filter: filter,
                seed: ""
            };
            return fetch(SDKbaseURI + searchAPI, {
                method: 'POST',
                headers: this.headers,
                body: JSON.stringify(body)
            })
                .then(response => response.json())
                .then((response) => {
                    return response ? response : null;
                });
        }).bind(this);
        if (useCache) {
            // return this.retry(this.cache.bind(this, `${productUltaId}-${sku}`, fn, true), 3);
            return this.cache(`${productUltaId}-${sku}`, fn, true);
        } else {
            // return this.retry(fn);
            return fn();
        }

    },
    forceHttps: function (product) {
        product.productImage = product.productImage.replace('http://', 'https://');
        product.palettes.forEach(pal => {
            pal.paletteImage = pal.paletteImage.replace('http://', 'https://');
        });
        return product;
    },
    fetchProducts: function (page, regions, seed, pageSize, skusToShowFirst) {
        //response.data[0].palettes[0].tones[0].hex
        const constructColor = function (colorObj) {
            var hex = colorObj.hex.substring(1);
            /* Get the RGB values to calculate the Hue. */
            var r = parseInt(hex.substring(0, 2), 16) / 255;
            var g = parseInt(hex.substring(2, 4), 16) / 255;
            var b = parseInt(hex.substring(4, 6), 16) / 255;

            /* Getting the Max and Min values for Chroma. */
            var max = Math.max.apply(Math, [r, g, b]);
            var min = Math.min.apply(Math, [r, g, b]);


            /* Variables for HSV value of hex color. */
            var chr = max - min;
            var hue = 0;
            var val = max;
            var sat = 0;


            if (val > 0) {
                /* Calculate Saturation only if Value isn't 0. */
                sat = chr / val;
                if (sat > 0) {
                    if (r == max) {
                        hue = 60 * (((g - min) - (b - min)) / chr);
                        if (hue < 0) {
                            hue += 360;
                        }
                    } else if (g == max) {
                        hue = 120 + 60 * (((b - min) - (r - min)) / chr);
                    } else if (b == max) {
                        hue = 240 + 60 * (((r - min) - (g - min)) / chr);
                    }
                }
            }
            colorObj.chroma = chr;
            colorObj.hue = hue;
            colorObj.sat = sat;
            colorObj.val = val;
            colorObj.luma = 0.3 * r + 0.59 * g + 0.11 * b;
            colorObj.red = parseInt(hex.substring(0, 2), 16);
            colorObj.green = parseInt(hex.substring(2, 4), 16);
            colorObj.blue = parseInt(hex.substring(4, 6), 16);
            return colorObj;
        };
        const sortByHex = (apiResp) => {
            if (Array.isArray(apiResp.data) && apiResp.data.length > 0) {
                for (let q = 0; q < apiResp.data.length; q++) {
                    const prod = apiResp.data[q];
                    if (Array.isArray(prod.palettes) && prod.palettes.length > 0) {
                        for (let w = 0; w < prod.palettes.length; w++) {
                            const palette = prod.palettes[w];
                            if (Array.isArray(palette.tones) && palette.tones.length > 0 &&
                                palette.tones[0] && palette.tones[0].hex) {
                                palette.color = constructColor({ hex: palette.tones[0].hex });
                            }
                        }
                    }
                    prod.palettes.sort((a, b) => {
                        return b.color.luma - a.color.luma;
                    });
                }
            }
            return apiResp;
        }
        const fn = (() => {
            const boost = [];
            if (Array.isArray(skusToShowFirst) && skusToShowFirst.length > 0) {
                boost.push({
                    PropName: 'palettes.sku',
                    Values: skusToShowFirst
                })
            }
            const body = {
                page: page ? page : 1,
                pageSize: pageSize || searchAPIPageSize,
                filter: regions ? { regions: regions } : {},
                boost: boost,
                seed: seed
            };
            return fetch(SDKbaseURI + searchAPI, {
                method: 'POST',
                headers: this.headers,
                body: JSON.stringify(body)
            })
                .then(response => response.json())
                .then((response) => {
                    // sort hexs
                    if (response) {
                        if (regions.indexOf('foundation') >= 0) {
                            response = sortByHex(response);
                        }
                        if (regions.length > 0) {
                            response.data = response.data.map(prod => {
                                prod.palettes = prod.palettes.map(pal => {
                                    pal.tones = pal.tones.filter(t => t.regions.find(r => regions.indexOf(r) >= 0));
                                    pal.regions = pal.regions.filter(r => regions.indexOf(r) >= 0);
                                    return pal;
                                });
                                return prod;
                            });
                        }
                        response.data = response.data.map(prod => this.forceHttps(prod));
                        return response;
                    } else {
                        return null;
                    }
                });
        }).bind(this);
        // console.log(page, regions, seed);
        if (useCache) {
            // return this.retry(this.cache.bind(this, `${page}-${regions}-${seed}`, fn, true), 3);
            return this.cache(`${page}-${regions}-${seed}`, fn, true);
        } else {
            // return this.retry(fn);
            return fn();
        }
    },
    addProductToBag: function (params) {
        return fetch(webBaseURI + cartURI + params, {
            headers: this.headers
        })
            .then(response => response.json())
    },
    checkInventory: function (params) {
        return fetch(webBaseURI + inventoryURI + params, {
            headers: this.headers
        })
            .then(response => response.json())
    },
    reStyleGetCategories: function () {
        return fetch(reStyleURI + reStyleCategories, {
            headers: {
                'x-api-key': reStyleURIkey,
            },
        })
            .then(response => response.json())
            .then(response => response.data);
    },
    reStyleUploadSelfie: function (file, from = null) {
        const data = new FormData();
        data.append('file', file);

        let url = reStyleURI + reStyleUploadSelfie;
        if (from) {
            url += '?hair_vto=' + from;
        }

        return fetch(url, {
            method: 'POST',
            headers: {
                'x-api-key': reStyleURIkey,
            },
            referer: "https://web-glamlab.ulta.com",
            body: data
        })
            .then(response => response.json())
            .then(response => response.data);
    },
    reStyleSetHairstyles: function (selfieId, genomeIds) {
        const url = reStyleURI + reStyleSetHairstyles
            .replace(':selfieId', selfieId)
            .replace(':genomeIds', genomeIds.join(','))

        return fetch(url, {
            method: 'PUT',
            headers: {
                'x-api-key': reStyleURIkey,
            },
            referer: "https://web-glamlab.ulta.com",
        })
            .then(response => response.json())
            .then(response => response.data);
    },
    reStyleGetSelfies: function (selfieId) {
        return fetch(reStyleURI + reStyleGetSelfies.replace(':selfieId', selfieId), {
            headers: {
                'x-api-key': reStyleURIkey,
            },
            referer: "https://web-glamlab.ulta.com",
        })
            .then(response => response.json())
            .then(response => response.data);
    },
    reStyleGetTransfers: function (selfieId, genomeIds) {
        const url = reStyleURI + reStyleGetTransfers
            .replace(':selfieId', selfieId)
            .replace(':genomeIds', genomeIds.join(','));

        return fetch(url, {
            method: 'GET',
            headers: {
                'x-api-key': reStyleURIkey,
            },
        })
            .then(response => response.json())
            .then(response => response.data);
    },
    reStyleGetConfigs: function () {
        return fetch(reStyleURI + reStyleGetConfigs, {
            headers: {
                'x-api-key': reStyleURIkey,
            },
            // referer: "https://web-glamlab.ulta.com"
        })
            .then(response => response.json())
            .then(response => response.data);
    },
    postNftActivity: async function (uid, actionId, value = null) {
        const url = nftActivityURI;
        const headers = {
            'x-api-key': nftActivityAPIKey,
            'Content-Type': 'application/json',
        };

        const payload = {
            uid: uid,
            actionId: actionId,
            application: '5',
        }

        if (value) {
            payload.value = value;
        }

        const response = await fetch(url, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        });
        return await response.json();
    },
};

export default APIhelper;